export const DATABASE_VIEW_STORAGE_PREFIX = 'database';

/** Dropdown option freshness window. Entries younger than this are reused; expired entries are reloaded on normal use. */
export const DATABASE_OPTIONS_TTL_MS = 1_800_000;
